import { Outlet } from "react-router-dom";
import axiosInstance from "@/services/api/axiosInstance";
import { useCallback, useEffect } from "react";
import useAuthStore from "@/zustand/authStore";
import { useQuery } from "@tanstack/react-query";
import { UserObj } from "@/types/interfaces/common";
import ErrorFallback from "@/components/ErrorFallback/ErrorFallback";
import Stack from "@mui/joy/Stack";
import LottieLoader from "@/components/Loader/LottieLoader";

const RootLayout = () => {
  const user = useAuthStore((state) => state.user);
  const setCurrentUser = useAuthStore((state) => state.setCurrentUser);

  // get current user
  const getCurrentUser = useCallback(async (): Promise<UserObj> => {
    const res = await axiosInstance.get(`/agents`);

    const data = res?.data;

    return data?.message || null;
  }, []);

  const currentUserQuery = useQuery({
    queryKey: ["currentUser"],
    queryFn: getCurrentUser,
  });

  // set current user
  useEffect(() => {
    if (currentUserQuery.data) {
      setCurrentUser(currentUserQuery.data);
    }
  }, [currentUserQuery.data]);

  // remove isSkipped
  useEffect(() => {
    localStorage.removeItem("isSkipped");
  }, []);

  if (currentUserQuery.error) {
    return <ErrorFallback retry={currentUserQuery.refetch} />;
  }

  if (user) {
    return <Outlet />;
  }

  return (
    <Stack
      alignItems={"center"}
      justifyContent={"center"}
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <LottieLoader />
    </Stack>
  );
};
export default RootLayout;
